window.slider = {
    rangeMin: 0,
    rangeMax: 3,
    to: (value) => {return value},

    init: function(options) {
        this.to = options.to;
        if(options.rangeMin){
            this.rangeMin = options.rangeMin;
        }
        if(options.rangeMax) {
            this.rangeMax = options.rangeMax
        }
        this.mount();
    },

    mount: function() {
        var slider = $('#budget-type-slider');
        var sliderValue = $('input#budget_type').val();
        noUiSlider.create(slider.get(0), {
            start: [sliderValue],
            connect: 'lower',
            cssPrefix: 'custom-noUi-',
            tooltips: [{to: this.to}],
            step: 1,
            range: {
                'min': this.rangeMin,
                'max': this.rangeMax
            },
            format: {
                to: function (value) {
                    return value;
                },
                from: function(value) {
                    return value;
                }
            }
        }).on('slide', function(values) {
            $('input#budget_type').val(values[0]);
        });
    }
}
